import { render, staticRenderFns } from "./event-conflicts.vue?vue&type=template&id=655f5269&scoped=true&"
import script from "./event-conflicts.ts?vue&type=script&lang=ts&"
export * from "./event-conflicts.ts?vue&type=script&lang=ts&"
import style0 from "./event-conflicts.scss?vue&type=style&index=0&id=655f5269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f5269",
  null
  
)

export default component.exports